import React, { useMemo } from "react";
import SearchSelect from "../SearchSelect/SearchSelect";

// Dentist search: matches name, role and areas of focus (e.g. "braces" finds the orthodontist).
const DentistPicker = ({ dentists, value, onChange, label = "Dentist", placeholder = "Search name or speciality", hint }) => {
  const items = useMemo(
    () =>
      dentists.map((d) => ({
        id: d.id,
        title: d.name,
        subtitle: `${d.role} · ${d.focus.join(", ")}`,
        avatar: d.initials,
        avatarStyle: { background: d.color, color: "#fff" },
        keywords: [d.name, d.role, ...d.focus].join(" "),
      })),
    [dentists]
  );
  return (
    <SearchSelect
      items={items}
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      hint={hint}
      emptyText={(q) => `No dentist matches "${q}".`}
    />
  );
};

export default DentistPicker;
